import Header from './components/header/header';
import { PredefinedRoute } from './components/predefined-route';
import WelcomeScreen from './screens/welcome-screen';
import i18n from './intl/i18n';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import React from 'react';
import ProductSelectionScreen from 'screens/product-selection-screen';
import { ROUTES } from 'helpers/constants';
import StylesSelectionScreen from 'screens/styles-selection-screen';
import ViewerScreen from 'screens/viewer/viewer-screen';
import LocationListenerWrapper from 'components/location-listener-wrapper/location-listener-wrapper';
import ViewerRouteGuard from 'screens/viewer/viewer-routeguard';
import { ChangeDimensionModal } from './components/change-dimension-modal';
import { ViewerLoadingMessage } from './components/viewer-loading-message';

function App() {
  // Setup location listener to save last location to ui-state

  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <LocationListenerWrapper>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: 'var(--app-height)',
            }}
          >
            <Header />
            <Switch>
              <ViewerRouteGuard
                path={[
                  ROUTES.QUOTE_SCREEN,
                  ROUTES.OPTIONS_SCREEN,
                  ROUTES.MATERIAL_SCREEN,
                  ROUTES.BUILD_SCREEN,
                ]}
              >
                <ViewerScreen />
              </ViewerRouteGuard>
              <Route path={ROUTES.PRODUCTS_SCREEN}>
                <PredefinedRoute component={ProductSelectionScreen} />
              </Route>
              <Route path={ROUTES.STYLES_SCREEN}>
                <PredefinedRoute component={StylesSelectionScreen} />
              </Route>
              {/* welcome screen comes last as route is least specific */}
              <Route path={ROUTES.WELCOME_SCREEN}>
                <PredefinedRoute component={WelcomeScreen} />
              </Route>
            </Switch>
          </div>
        </LocationListenerWrapper>
      </Router>

      <ViewerLoadingMessage />
      <ChangeDimensionModal />
    </I18nextProvider>
  );
}

export default App;
